import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import clinicLogo from '../../assets/logo.png';
import footerLogo from '../../assets/footer_logo.png';
import mastermindLogo from '../../assets/mm.png';
import shahImg from '../../assets/about/shah.jpeg';
import { FaTooth, FaStethoscope, FaCrown, FaSmile, FaMagic, FaChild, FaSyringe, FaTint, FaLeaf, FaWrench, FaGrin, FaAmbulance } from 'react-icons/fa';
import Testimonial from '../../components/Testimonial/Testimonial';

export default function DoctorLandingPage() {
    const [isSubmitted] = useState(false);
    const [openFaq, setOpenFaq] = useState(0);
    const [selectedReason, setSelectedReason] = useState('General Checkup / Cleaning');
    // eslint-disable-next-line no-unused-vars
    const reviewScrollRef = useRef(null);
    const galleryScrollRef = useRef(null);
    const navigate = useNavigate();

    const scrollContainer = (ref, direction) => {
        if (ref.current) {
            const scrollAmount = typeof window !== 'undefined' ? window.innerWidth * 0.75 : 300;
            ref.current.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const name = formData.get('name');
        const phone = formData.get('phone');
        const reason = formData.get('reason');

        if (!name?.trim() || !phone?.trim()) {
            alert('Please add your name and number.');
            return;
        }

        const nameRegex = /^[A-Za-z\s]+$/;
        if (!nameRegex.test(name.trim())) {
            alert('Please enter a valid name (letters only).');
            return;
        }

        const phoneRegex = /^\d{10}$/;
        if (!phoneRegex.test(phone.trim())) {
            alert('Please enter a valid 10-digit phone number.');
            return;
        }

        // GTM Conversion Tracking
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                event: 'generate_lead',
                lead_source: 'ppc3',
            });
        }

        const message = `Hi Kosmix Dental Clinic, I'd like to book an appointment.\n\nName: ${name.trim()}\nPhone: ${phone.trim()}\nTreatment: ${reason}\n\n(Lead from Landing Page PPC3)`;
        const encodedMessage = encodeURIComponent(message);
        window.open(`https://wa.me/919035289171?text=${encodedMessage}`, '_blank');

        navigate(`/thankyou?source=${encodeURIComponent(window.location.pathname)}`);
    };



    return (
        <div className="font-sans text-[#3f0f0a] bg-[#f3e9dc] leading-relaxed pb-[72px] md:pb-0 antialiased">
            <header className="bg-white py-3 px-[18px] border-b border-[#8f7874]/30 sticky top-0 z-40">
                <div className="max-w-[640px] md:max-w-[1000px] mx-auto flex justify-between items-center">
                    <div className="flex items-center gap-2 md:gap-3 min-w-0">
                        <div className="relative w-[36px] h-[36px] md:w-[40px] md:h-[40px] flex-shrink-0">
                            <img
                                src={clinicLogo}
                                alt="Prodent Logo"
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <div className="flex flex-col justify-center min-w-0">
                            <span className="leading-none mb-0.5 text-[1rem] md:text-[1.05rem] font-bold truncate">Kosmix Dental Clinic</span>
                        </div>
                    </div>
                    {/* Hide Call button on mobile since we have the bottom floating action bar */}
                    <a
                        className="hidden md:inline-flex bg-[#f3e9dc] text-[#3f0f0a] font-extrabold text-[0.85rem] px-3 py-2 rounded-xl hover:bg-[#8f7874]/30 transition-colors focus-visible:outline-[3px] focus-visible:outline-[#601710] focus-visible:outline-offset-2 flex-shrink-0"
                        href="tel:+919035289171"
                    >
                        📞 Call
                    </a>
                </div>
            </header>

            {/* HERO — DOCTOR AUTHORITY */}
            <section className="bg-gradient-to-br from-[#1f0c0a] to-[#3f0f0a] text-white pt-[30px] pb-[40px] md:py-[60px] overflow-hidden">
                <div className="max-w-[640px] md:max-w-[1000px] mx-auto px-[18px] flex flex-col md:grid md:grid-cols-[1.1fr_1fr] md:gap-[50px] md:items-center">

                    {/* Text Content */}
                    <div className="text-left mt-0 mb-10 md:mb-0">
                        <span className="inline-block text-[0.75rem] font-extrabold tracking-[0.14em] uppercase text-[#FF8A00] mb-3">
                            Specialist Dental Care
                        </span>
                        <h1 className="text-[2.2rem] md:text-[3.2rem] font-extrabold leading-[1.15] mb-4 text-white">
                            Meet <em className="text-[#FF8A00] not-italic">Dr. Shankhadeep</em> & <em className="text-[#FF8A00] not-italic">Dr. Sophia</em> — HSR Layout's trusted dental team
                        </h1>
                        <p className="text-white/80 text-[1.05rem] md:text-[1.15rem] mb-6">
                            Expert care by MDS specialists in advanced dental implants, painless root canals (RCT), and aesthetic smile designing. Over 9 years of delivering healthy, confident smiles in Bengaluru.
                        </p>
                        <div className="flex flex-wrap gap-2.5 mb-6 justify-start">
                            <span className="bg-white/10 text-white text-[0.8rem] font-bold py-[8px] px-[12px] rounded-lg border border-white/10">
                                🦷 Implants & RCT
                            </span>
                            <span className="bg-white/10 text-white text-[0.8rem] font-bold py-[8px] px-[12px] rounded-lg border border-white/10">
                                ✨ Smile Designing
                            </span>
                            <span className="bg-white/10 text-white text-[0.8rem] font-bold py-[8px] px-[12px] rounded-lg border border-white/10">
                                🩺 9+ yrs Experience
                            </span>
                        </div>
                        <div className="text-white text-[0.8rem] sm:text-[0.85rem] md:text-[0.9rem] font-bold mb-6 leading-[1.6]">
                            <span className="text-[#FF8A00] text-lg tracking-widest mr-1">★★★★★</span> <span>4.9 · 500+ Google reviews · 500+ patients · Open till 11:00 PM</span>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <a
                                className="inline-flex items-center justify-center gap-2 font-extrabold text-[1.05rem] py-[16px] px-[20px] rounded-xl border-0 cursor-pointer w-full transition-all duration-150 active:translate-y-[1px] bg-[#601710] text-white hover:bg-[#3f0f0a] shadow-lg shadow-[#1f0c0a]/50"
                                href="tel:+919035289171"
                            >
                                📞 Call now
                            </a>
                            <a
                                className="inline-flex items-center justify-center gap-2 font-extrabold text-[1.05rem] py-[16px] px-[20px] rounded-xl border-0 cursor-pointer w-full transition-all duration-150 active:translate-y-[1px] bg-[#25D366] text-white hover:bg-[#1EBE5B] shadow-lg shadow-green-900/30 group"
                                href="https://wa.me/919035289171?text=Hi%20Kosmix%20Dental%20Clinic%2C%20I%27d%20like%20to%20book%20an%20appointment%20with%20your%20specialists."
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <svg className="w-[22px] h-[22px] fill-current group-hover:scale-110 transition-transform" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                                </svg>
                                WhatsApp
                            </a>
                        </div>
                    </div>

                    {/* Images Section */}
                    <div className="relative flex justify-center items-center px-2 sm:px-4 md:px-0 w-full mt-6 md:mt-0">
                        <div className="flex justify-center items-center gap-3 sm:gap-4 md:gap-0 md:relative md:w-full md:max-w-[440px] md:aspect-[4/4.5] lg:aspect-[4/5] mx-auto">
                            {/* Doctor 1 */}
                            <div className="relative w-[48%] md:w-[68%] aspect-[3/4] rounded-2xl overflow-hidden border-2 md:border-4 border-[#3f0f0a] shadow-xl md:shadow-2xl z-10 md:absolute md:top-0 md:left-0 md:transform md:-rotate-2 hover:rotate-0 transition-transform duration-300">
                                <img
                                    src={shahImg}
                                    alt="Dr. Shankhadeep Saha"
                                    className="w-full h-full object-cover object-top"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1f0c0a]/90 via-[#1f0c0a]/40 to-transparent px-3 pb-3 pt-10 md:px-4 md:pb-4 md:pt-12">
                                    <p className="text-white font-bold text-[0.75rem] sm:text-sm leading-tight" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.8)' }}>Dr. Shankhadeep Saha</p>
                                </div>
                            </div>

                            {/* Doctor 2 */}
                            <div className="relative w-[48%] md:w-[64%] aspect-[3/4] rounded-2xl overflow-hidden border-2 md:border-4 border-[#3f0f0a] shadow-xl md:shadow-2xl z-20 md:absolute md:bottom-0 md:right-0 md:translate-y-6 md:translate-x-4 md:transform md:rotate-2 hover:rotate-0 transition-transform duration-300">
                                <img
                                    src="/lp_ppc1/Saul.jpeg"
                                    alt="Dr. Sophia Saud"
                                    className="w-full h-full object-cover object-top"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1f0c0a]/90 via-[#1f0c0a]/40 to-transparent px-3 pb-3 pt-10 md:px-4 md:pb-4 md:pt-12">
                                    <p className="text-white font-bold text-[0.75rem] sm:text-sm leading-tight" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.8)' }}>Dr. Sophia Saud</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SIGNATURE QUOTE */}
            <section className="py-6 md:py-8 pb-2 md:pb-6">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto px-[18px]">
                    <div className="bg-[#f3e9dc] border-l-[3px] md:border-l-4 border-[#FF8A00] rounded-xl p-4 md:p-6 mt-2 md:mt-8 relative shadow-sm">
                        <p className="text-[1rem] md:text-[1.1rem] text-[#3f0f0a] font-semibold leading-relaxed italic">
                            &quot;Our goal is simple — treatment that&apos;s genuinely painless, explained clearly, and done right the first time for you and your family.&quot;
                        </p>
                        <div className="mt-3 text-[#8f7874] text-[0.8rem] md:text-[0.85rem] font-bold">
                            — Dr. Shankhadeep Saha <span className="hidden sm:inline">&amp;</span><span className="sm:hidden text-slate-400 font-normal mx-1">&amp;</span> Dr. Sophia Saud
                        </div>
                    </div>
                </div>
            </section>

            {/* RIBBON */}
            <div className="bg-[#1f0c0a] border-y border-[#3f0f0a] text-white shadow-inner">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4 py-8 md:py-[22px] px-[18px]">
                    <div className="stat text-center md:text-left flex flex-col items-center md:items-start">
                        <div className="text-[1.3rem] md:text-[1.5rem] font-extrabold text-[#FF8A00] leading-none mb-1">Since 2018</div>
                        <div className="text-[0.75rem] md:text-[0.8rem] opacity-85 font-medium">Trusted clinic</div>
                    </div>
                    <div className="stat text-center md:text-left flex flex-col items-center md:items-start">
                        <div className="text-[1.3rem] md:text-[1.5rem] font-extrabold text-[#FF8A00] leading-none mb-1">5,000+</div>
                        <div className="text-[0.75rem] md:text-[0.8rem] opacity-85 font-medium">Happy patients</div>
                    </div>
                    <div className="stat text-center md:text-left flex flex-col items-center md:items-start">
                        <div className="text-[1.3rem] md:text-[1.5rem] font-extrabold text-[#FF8A00] leading-none mb-1">2</div>
                        <div className="text-[0.75rem] md:text-[0.8rem] opacity-85 font-medium">Specialist dentists</div>
                    </div>
                    <div className="stat text-center md:text-left flex flex-col items-center md:items-start">
                        <div className="text-[1.3rem] md:text-[1.5rem] font-extrabold text-[#FF8A00] leading-none mb-1">5 ★</div>
                        <div className="text-[0.75rem] md:text-[0.8rem] opacity-85 font-medium">100+ Google reviews</div>
                    </div>
                </div>
            </div>

            {/* TECH AUTHORITY */}
            <section className="pt-5 pb-2 md:pt-8 md:pb-3">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto px-[18px]">
                    <div className="text-center md:text-left mb-4 md:mb-6">
                        <span className="inline-block text-[0.75rem] md:text-[0.85rem] font-extrabold tracking-[0.14em] uppercase text-[#601710] mb-2">
                            The difference
                        </span>
                        <h2 className="text-[#1f0c0a] text-2xl md:text-3xl lg:text-[2.2rem] leading-[1.15] tracking-tight font-extrabold">
                            Advanced dentistry, close to home
                        </h2>
                    </div>

                    <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-5 md:p-8 shadow-sm">
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 list-none">
                            <li className="flex gap-3 md:gap-4 items-center">
                                <span className="text-[1.6rem] md:text-[1.8rem] flex-shrink-0 bg-[#FCE9EC] w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center">🩻</span>
                                <div>
                                    <b className="block text-[#1f0c0a] text-[1rem] md:text-[1.05rem] mb-0 md:mb-1">3D intraoral scanner</b>
                                    <span className="hidden md:block text-[#8f7874] text-[0.85rem] md:text-[0.95rem] leading-relaxed">In-house 3D imaging for precise, confident diagnosis — no outside referrals.</span>
                                </div>
                            </li>
                            <li className="flex gap-3 md:gap-4 items-center">
                                <span className="text-[1.6rem] md:text-[1.8rem] flex-shrink-0 bg-[#FCE9EC] w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center">⚡</span>
                                <div>
                                    <b className="block text-[#1f0c0a] text-[1rem] md:text-[1.05rem] mb-0 md:mb-1">Painless root canals</b>
                                    <span className="hidden md:block text-[#8f7874] text-[0.85rem] md:text-[0.95rem] leading-relaxed">Most RCTs completed painlessly in one visit.</span>
                                </div>
                            </li>
                            <li className="flex gap-3 md:gap-4 items-center">
                                <span className="text-[1.6rem] md:text-[1.8rem] flex-shrink-0 bg-[#FCE9EC] w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center">🦷</span>
                                <div>
                                    <b className="block text-[#1f0c0a] text-[1rem] md:text-[1.05rem] mb-0 md:mb-1">3D-guided implants</b>
                                    <span className="hidden md:block text-[#8f7874] text-[0.85rem] md:text-[0.95rem] leading-relaxed">Planned digitally for accuracy, comfort and faster healing.</span>
                                </div>
                            </li>
                            <li className="flex gap-3 md:gap-4 items-center">
                                <span className="text-[1.6rem] md:text-[1.8rem] flex-shrink-0 bg-[#FCE9EC] w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center">🕙</span>
                                <div>
                                    <b className="block text-[#1f0c0a] text-[1rem] md:text-[1.05rem] mb-0 md:mb-1">Open till 11:00 PM, daily</b>
                                    <span className="hidden md:block text-[#8f7874] text-[0.85rem] md:text-[0.95rem] leading-relaxed">Care that fits around work and family.</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* SERVICES */}
            <section className="pt-2 pb-5 md:pt-3 md:pb-8">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto px-[18px]">
                    <div className="text-center md:text-left mb-4 md:mb-6">
                        <span className="inline-block text-[0.75rem] md:text-[0.85rem] font-extrabold tracking-[0.14em] uppercase text-[#601710] mb-2">
                            Treatments
                        </span>
                        <h2 className="text-[#1f0c0a] text-2xl md:text-3xl lg:text-[2.2rem] leading-[1.15] tracking-tight font-extrabold">
                            Comprehensive Dental Care
                        </h2>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaTooth className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Dental Implants</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">3D-guided, painless</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaStethoscope className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Painless RCT</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">One visit, no pain</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaCrown className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Crowns & Bridges</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Natural-looking</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaSmile className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Braces & Aligners</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Clear options</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaMagic className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Whitening & Veneers</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Smile design</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaChild className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Kids & Family</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Gentle care</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaSyringe className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Tooth Extraction</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Incl. wisdom tooth removal</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaTint className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Teeth Cleaning & Scaling</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Routine hygiene, fresh in 30 min</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaLeaf className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Gum Care & Laser Treatment</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">LANAP — Dr. Saha's specialty</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaWrench className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Full Mouth Rehabilitation</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Complete smile restoration</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaGrin className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Dentures</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Comfortable, custom-fit</span>
                            </div>
                        </div>

                        <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 text-left">
                            <div className="bg-[#FCE9EC] text-[#601710] w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0">
                                <FaAmbulance className="w-5 h-5 md:w-6 md:h-6" />
                            </div>
                            <div className="flex flex-col">
                                <b className="block text-[#1f0c0a] text-[0.85rem] md:text-[0.95rem] leading-tight mb-0.5">Emergency Dental Care</b>
                                <span className="hidden md:block text-[#8f7874] text-[0.85rem] leading-snug">Same-day pain relief</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* REVIEWS */}
            <section className="py-[32px] md:py-[48px] overflow-hidden">
                <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px]">
                    <Testimonial />
                </div>
            </section>

            {/* GALLERY */}
            <section className="py-5 pt-2 pb-2">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto px-[18px]">
                    <div className="flex justify-between items-end mb-4">
                        <div>
                            <span className="inline-block text-[0.72rem] font-extrabold tracking-[0.14em] uppercase text-[#601710] mb-2">
                                Real results
                            </span>
                            <h2 className="text-[#1f0c0a] text-2xl leading-[1.15] tracking-tight font-extrabold">
                                Kosmix Dental Clinic's case gallery
                            </h2>
                            <p className="text-[#8f7874] mt-1 text-[0.85rem]">Before & after (with patient consent).</p>
                        </div>
                        <div className="flex gap-2 mb-1">
                            <button onClick={() => scrollContainer(galleryScrollRef, 'left')} className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#FCE9EC] text-[#601710] flex items-center justify-center border border-[#FCE9EC] hover:bg-[#FCE9EC] transition-colors shrink-0" aria-label="Previous case">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>
                            </button>
                            <button onClick={() => scrollContainer(galleryScrollRef, 'right')} className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#FCE9EC] text-[#601710] flex items-center justify-center border border-[#FCE9EC] hover:bg-[#FCE9EC] transition-colors shrink-0" aria-label="Next case">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6" /></svg>
                            </button>
                        </div>
                    </div>
                    <div ref={galleryScrollRef} className="flex gap-2.5 overflow-x-auto pt-1 pb-1.5 -mx-[18px] px-[18px] snap-x snap-mandatory [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
                        <div className="flex-[0_0_70%] md:flex-[0_0_32%] snap-start rounded-2xl overflow-hidden aspect-square bg-[#f3e9dc] border border-[#8f7874]/30 relative group">
                            <img src="/lp_ppc1/img1.jpeg" alt="Clinic Gallery 1" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                        </div>
                        <div className="flex-[0_0_70%] md:flex-[0_0_32%] snap-start rounded-2xl overflow-hidden aspect-square bg-[#f3e9dc] border border-[#8f7874]/30 relative group">
                            <img src="/lp_ppc1/img2.jpeg" alt="Clinic Gallery 2" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                        </div>
                        <div className="flex-[0_0_70%] md:flex-[0_0_32%] snap-start rounded-2xl overflow-hidden aspect-square bg-[#f3e9dc] border border-[#8f7874]/30 relative group">
                            <img src="/lp_ppc1/img3.jpeg" alt="Clinic Gallery 3" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                        </div>
                        <div className="flex-[0_0_70%] md:flex-[0_0_32%] snap-start rounded-2xl overflow-hidden aspect-square bg-[#f3e9dc] border border-[#8f7874]/30 relative group">
                            <img src="/lp_ppc1/img4.jpeg" alt="Clinic Gallery 4" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                        </div>
                        <div className="flex-[0_0_70%] md:flex-[0_0_32%] snap-start rounded-2xl overflow-hidden aspect-square bg-[#f3e9dc] border border-[#8f7874]/30 relative group">
                            <img src="/lp_ppc1/img5.jpeg" alt="Clinic Gallery 5" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                        </div>
                        <div className="flex-[0_0_70%] md:flex-[0_0_32%] snap-start rounded-2xl overflow-hidden aspect-square bg-[#f3e9dc] border border-[#8f7874]/30 relative group">
                            <img src="/lp_ppc1/img6.jpeg" alt="Clinic Gallery 6" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                        </div>
                    </div>
                </div>
            </section>

            {/* LOCATION */}
            <section className="py-5 pt-2">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto px-[18px]">
                    <div className="text-center md:text-left mb-5 md:mb-8">
                        <span className="inline-block text-[0.72rem] font-extrabold tracking-[0.14em] uppercase text-[#601710] mb-2">
                            Find the clinic
                        </span>
                        <h2 className="text-[#1f0c0a] text-2xl md:text-3xl leading-[1.15] tracking-tight font-extrabold">
                            Dental Clinic in HSR Layout, Bengaluru
                        </h2>
                    </div>

                    <div className="md:grid md:grid-cols-2 md:gap-10 md:items-center">
                        <div className="rounded-2xl overflow-hidden border border-[#8f7874]/30 aspect-[4/3] md:aspect-square bg-[#8f7874]/30 shadow-sm mb-5 md:mb-0">
                            <iframe
                                title="Kosmix Dental Clinic Google Maps Location"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.9989629433803!2d77.6485828!3d12.907787899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae149953a107f5%3A0xdb63ec5c78e614!2sKosmix%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1737028890133!5m2!1sen!2sin"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen={true}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>

                        <div className="grid gap-3 md:gap-4">
                            <div className="flex gap-4 items-start bg-[#f3e9dc] p-4 rounded-2xl border border-[#f3e9dc]">
                                <div className="w-10 h-10 rounded-full bg-white text-[#601710] flex items-center justify-center shrink-0 shadow-sm border border-[#f3e9dc] text-[1.1rem]">📍</div>
                                <div>
                                    <b className="block text-[#1f0c0a] text-[0.95rem] mb-0.5">Address</b>
                                    <span className="text-[#8f7874] text-[0.9rem] leading-relaxed block">
                                        1175, 24th Main Rd, near Shri Maramma Devi Devasthana,<br />Garden Layout, Sector 2, HSR Layout, Bengaluru, Karnataka 560102
                                    </span>
                                </div>
                            </div>
                            <div className="flex gap-4 items-start bg-[#f3e9dc] p-4 rounded-2xl border border-[#f3e9dc]">
                                <div className="w-10 h-10 rounded-full bg-white text-[#601710] flex items-center justify-center shrink-0 shadow-sm border border-[#f3e9dc] text-[1.1rem]">🕙</div>
                                <div>
                                    <b className="block text-[#1f0c0a] text-[0.95rem] mb-0.5">Hours</b>
                                    <span className="text-[#8f7874] text-[0.9rem] leading-relaxed block">Mon to Sun · 10:00 AM – 11:00 PM</span>
                                </div>
                            </div>
                            <div className="flex gap-4 items-start bg-[#f3e9dc] p-4 rounded-2xl border border-[#f3e9dc]">
                                <div className="w-10 h-10 rounded-full bg-white text-[#601710] flex items-center justify-center shrink-0 shadow-sm border border-[#f3e9dc] text-[1.1rem]">📞</div>
                                <div>
                                    <b className="block text-[#1f0c0a] text-[0.95rem] mb-0.5">Phone</b>
                                    <span className="text-[#8f7874] text-[0.9rem] leading-relaxed block">
                                        <a href="tel:+919035289171" className="text-[#601710] font-bold hover:underline">090352 89171</a><br />
                                        <a href="tel:08042083115" className="text-[#601710] font-bold hover:underline">080 4208 3115</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ */}
            <section className="py-5 pt-2">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto px-[18px]">
                    <div className="md:grid md:grid-cols-12 md:gap-10 md:items-start">
                        <div className="md:col-span-4 text-center md:text-left mb-6 md:mb-0 md:sticky md:top-24">
                            <span className="inline-block text-[0.72rem] font-extrabold tracking-[0.14em] uppercase text-[#601710] mb-2">
                                Good to know
                            </span>
                            <h2 className="text-[#1f0c0a] text-2xl md:text-3xl leading-[1.15] tracking-tight font-extrabold">
                                Frequently Asked Questions
                            </h2>
                            <p className="text-[#8f7874] mt-3 text-[0.9rem] hidden md:block leading-relaxed">
                                Have more questions? Feel free to reach out to our clinic directly.
                            </p>
                        </div>

                        <div className="md:col-span-8 grid gap-3">
                            <details className="bg-white border border-[#8f7874]/30 rounded-2xl px-5 group open:shadow-sm transition-all duration-200" open={openFaq === 0} onClick={(e) => { e.preventDefault(); setOpenFaq(openFaq === 0 ? -1 : 0); }}>
                                <summary className="list-none cursor-pointer font-bold text-[#1f0c0a] text-[0.95rem] py-4 flex justify-between items-center gap-3 [&::-webkit-details-marker]:hidden">
                                    What are Kosmix Dental Clinic&apos;s qualifications?
                                    <span className="w-6 h-6 rounded-full bg-[#f3e9dc] flex items-center justify-center shrink-0 text-[#601710] transition-transform duration-300 group-open:rotate-180">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6" /></svg>
                                    </span>
                                </summary>
                                <p className="text-[#8f7874] text-[0.9rem] pb-5 leading-relaxed">
                                    Our doctors, including Dr. Shankhadeep Saha and Dr. Sophia Saud, are highly skilled specialists with extensive experience in endodontics, implantology, and modern treatments. We have been providing quality, affordable care for years in HSR Layout.
                                </p>
                            </details>

                            <details className="bg-white border border-[#8f7874]/30 rounded-2xl px-5 group open:shadow-sm transition-all duration-200" open={openFaq === 1} onClick={(e) => { e.preventDefault(); setOpenFaq(openFaq === 1 ? -1 : 1); }}>
                                <summary className="list-none cursor-pointer font-bold text-[#1f0c0a] text-[0.95rem] py-4 flex justify-between items-center gap-3 [&::-webkit-details-marker]:hidden">
                                    Do you use 3D scanning?
                                    <span className="w-6 h-6 rounded-full bg-[#f3e9dc] flex items-center justify-center shrink-0 text-[#601710] transition-transform duration-300 group-open:rotate-180">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6" /></svg>
                                    </span>
                                </summary>
                                <p className="text-[#8f7874] text-[0.9rem] pb-5 leading-relaxed">
                                    Yes — our in-house 3D intraoral scanner allows for precise, single-visit diagnoses, guided implant placements, and comfortable digital impressions without the traditional goop.
                                </p>
                            </details>

                            <details className="bg-white border border-[#8f7874]/30 rounded-2xl px-5 group open:shadow-sm transition-all duration-200" open={openFaq === 2} onClick={(e) => { e.preventDefault(); setOpenFaq(openFaq === 2 ? -1 : 2); }}>
                                <summary className="list-none cursor-pointer font-bold text-[#1f0c0a] text-[0.95rem] py-4 flex justify-between items-center gap-3 [&::-webkit-details-marker]:hidden">
                                    Where is the clinic located?
                                    <span className="w-6 h-6 rounded-full bg-[#f3e9dc] flex items-center justify-center shrink-0 text-[#601710] transition-transform duration-300 group-open:rotate-180">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6" /></svg>
                                    </span>
                                </summary>
                                <p className="text-[#8f7874] text-[0.9rem] pb-5 leading-relaxed">
                                    We are at 1175, 24th Main Rd, near Shri Maramma Devi Devasthana, Garden Layout, Sector 2, HSR Layout, Bengaluru, Karnataka 560102. There is ample street parking available right outside.
                                </p>
                            </details>
                        </div>
                    </div>
                </div>
            </section>

            {/* FORM */}
            <section id="book" className="py-5 pt-0">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto px-[18px]">
                    <span className="inline-block text-[0.72rem] font-extrabold tracking-[0.14em] uppercase text-[#601710] mb-2">
                        Consult an Expert
                    </span>
                    <h2 className="text-[#1f0c0a] text-2xl leading-[1.15] tracking-tight font-extrabold">
                        Request an appointment
                    </h2>
                    <div className="bg-white border border-[#8f7874]/30 rounded-2xl p-[18px] shadow-sm mt-[14px]">
                        {!isSubmitted ? (
                            <form id="bf" noValidate onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="block text-[0.8rem] font-bold text-[#1f0c0a] mb-1.5">Name</label>
                                    <input
                                        name="name"
                                        autoComplete="name"
                                        placeholder="Your name"
                                        required
                                        className="w-full px-[14px] py-[13px] border-[1.5px] border-[#8f7874]/30 rounded-xl text-base font-sans bg-[#f3e9dc] focus:border-[#601710] focus:bg-white focus:outline-none focus:ring-0 transition-colors placeholder:text-slate-400"
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="block text-[0.8rem] font-bold text-[#1f0c0a] mb-1.5">Phone / WhatsApp</label>
                                    <input
                                        name="phone"
                                        type="tel"
                                        autoComplete="tel"
                                        placeholder="Your number"
                                        required
                                        maxLength={10}
                                        onInput={(e) => {
                                            e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, '');
                                        }}
                                        className="w-full px-[14px] py-[13px] border-[1.5px] border-[#8f7874]/30 rounded-xl text-base font-sans bg-[#f3e9dc] focus:border-[#601710] focus:bg-white focus:outline-none focus:ring-0 transition-colors placeholder:text-slate-400"
                                    />
                                </div>

                                <div className="mb-4 mt-4">
                                    <label className="block text-[0.8rem] font-bold text-[#1f0c0a] mb-2.5">
                                        What do you need? <span className="text-[#8f7874] font-normal ml-1">(select one)</span>
                                    </label>
                                    <div className="flex flex-wrap gap-2.5">
                                        {[
                                            "General Checkup / Cleaning",
                                            "Fillings & Restorations",
                                            "Root Canal Treatment",
                                            "Dental Implants",
                                            "Crowns & Bridges",
                                            "Braces / Clear Aligners",
                                            "Teeth Whitening",
                                            "Tooth Extraction",
                                            "Full Mouth Rehabilitation",
                                            "Dentures",
                                            "Kids' Dentistry",
                                            "Dental Emergency / Pain",
                                            "Not Sure — Need Advice"
                                        ].map((reason) => (
                                            <button
                                                key={reason}
                                                type="button"
                                                onClick={() => setSelectedReason(reason)}
                                                className={`px-3.5 py-1.5 rounded-full text-[0.85rem] font-medium transition-all duration-200 border ${selectedReason === reason
                                                    ? 'bg-[#601710] text-white border-[#601710] shadow-md'
                                                    : 'bg-[#f4ebe1] text-[#3f0f0a] border-[#e8d5c4] hover:bg-[#e8d5c4]'
                                                    }`}
                                            >
                                                {reason}
                                            </button>
                                        ))}
                                    </div>
                                    <input type="hidden" name="reason" value={selectedReason} />
                                </div>
                                <button
                                    className="inline-flex items-center justify-center gap-2 font-extrabold text-[1.05rem] py-[16px] px-[20px] rounded-2xl border-0 cursor-pointer w-full transition-all duration-150 active:translate-y-[2px] bg-[#601710] text-white hover:bg-[#3f0f0a] focus-visible:outline-[3px] focus-visible:outline-[#601710] focus-visible:outline-offset-2 shadow-lg shadow-[#1f0c0a]/30 mt-2"
                                    type="submit"
                                >
                                    Request appointment
                                </button>
                            </form>
                        ) : (
                            <div className="bg-green-50 rounded-2xl p-8 text-center text-green-800 border border-green-200 font-bold flex flex-col items-center justify-center min-h-[300px]" id="ok">
                                <div className="w-16 h-16 bg-[#25D366] text-white rounded-full flex items-center justify-center mb-4 shadow-lg shadow-[#25D366]/30 mx-auto">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                                </div>
                                <h3 className="text-xl mb-2 text-green-900">Request Sent!</h3>
                                <p className="text-green-700/80 font-medium">Thanks! The clinic will contact you shortly to confirm your appointment.</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* FOOTER */}
            <footer className="bg-[#1f0c0a] text-white/85 py-12 mt-[18px]">
                <div className="max-w-[640px] md:max-w-[960px] mx-auto px-[18px]">
                    <div className="flex flex-col md:flex-row justify-between items-start gap-8">
                        <div>
                            <div className="flex items-center gap-3.5 font-extrabold text-white text-[1.1rem] mb-5">
                                <img
                                    src={footerLogo}
                                    alt="Kosmix Dental Clinic Logo"
                                    height={48}
                                    className="h-[48px] w-auto object-contain"
                                />
                                <div className="flex flex-col justify-center">
                                    <span className="leading-none mb-1 text-[1.15rem]">Kosmix Dental Clinic</span>
                                </div>
                            </div>
                            <div className="text-[0.9rem] leading-[1.8] text-white/80">
                                1175, 24th Main Rd, near Shri Maramma Devi Devasthana,<br className="hidden md:block" /> Garden Layout, Sector 2, HSR Layout, Bengaluru, Karnataka 560102
                            </div>
                        </div>

                        <div className="text-[0.9rem] leading-[1.8] md:text-right mt-2 md:mt-0">
                            <div className="mb-2 font-bold text-slate-400 tracking-wider uppercase text-[0.75rem]">Contact & Hours</div>
                            <div className="flex flex-col gap-2.5 mb-3">
                                <a href="tel:+919035289171" className="text-white font-semibold hover:text-[#FF8A00] transition-colors inline-flex items-center md:justify-end gap-2">
                                    <svg className="w-4 h-4 text-[#FF8A00] md:order-last" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                                    090352 89171
                                </a>
                                <a href="tel:08042083115" className="text-white font-semibold hover:text-[#FF8A00] transition-colors inline-flex items-center md:justify-end gap-2">
                                    <svg className="w-4 h-4 text-[#FF8A00] md:order-last" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                                    080 4208 3115
                                </a>
                            </div>
                            <div className="flex items-center md:justify-end gap-2 text-white/80">
                                <svg className="w-4 h-4 text-[#FF8A00] md:order-last" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                Mon to Sun · 10:00 AM – 11:00 PM
                            </div>
                        </div>
                    </div>
                    <div className="mt-6 pt-5 border-t border-[#3f0f0a] flex justify-center">
                        <a href="https://www.mastermindweb.in/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:scale-105 transition-transform">
                            <img
                                src={mastermindLogo}
                                alt="MasterMind Logo"
                                height={75}
                                className="opacity-90 hover:opacity-100 transition-opacity w-auto"
                            />
                        </a>
                    </div>
                </div>
            </footer>

            {/* FLOATING ACTION BAR */}
            <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#8f7874]/30 z-50 flex md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" aria-label="Quick actions">
                <a href="tel:+919035289171" className="flex-1 flex flex-col items-center justify-center pt-[12px] pb-[calc(12px+env(safe-area-inset-bottom,0px))] gap-[4px] text-[#8f7874] hover:text-teal-600 hover:bg-[#f3e9dc] transition-colors">
                    <svg className="w-[22px] h-[22px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#16a34a"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" /></svg>
                    <span className="text-[0.65rem] font-bold uppercase tracking-wider">Phone</span>
                </a>
                <a href="https://maps.google.com/?q=Kosmix+Dental+Clinic+HSR+Layout" target="_blank" rel="noreferrer" className="flex-1 flex flex-col items-center justify-center pt-[12px] pb-[calc(12px+env(safe-area-inset-bottom,0px))] gap-[4px] text-[#8f7874] hover:text-teal-600 hover:bg-[#f3e9dc] transition-colors border-l border-[#f3e9dc]">
                    <svg className="w-[22px] h-[22px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0d9488"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z" /></svg>
                    <span className="text-[0.65rem] font-bold uppercase tracking-wider">Address</span>
                </a>
                <a href="https://wa.me/919035289171?text=Hi%2C%20I%27d%20like%20to%20book%20a%20dental%20appointment" className="flex-1 flex flex-col items-center justify-center pt-[12px] pb-[calc(12px+env(safe-area-inset-bottom,0px))] gap-[4px] text-[#8f7874] hover:text-teal-600 hover:bg-[#f3e9dc] transition-colors border-l border-[#f3e9dc]">
                    <svg className="w-[22px] h-[22px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#25D366"><path d="M12.01 2.01c-5.5 0-9.98 4.47-9.98 9.97 0 1.98.58 3.82 1.58 5.37L2 22l4.82-1.57c1.48.92 3.23 1.45 5.09 1.45 5.5 0 9.98-4.47 9.98-9.97 0-5.5-4.48-9.97-9.98-9.97zM17.43 16.48c-.28.8-1.59 1.53-2.22 1.63-.56.09-1.28.25-3.66-.73-2.88-1.18-4.73-4.14-4.87-4.32-.14-.19-1.17-1.55-1.17-2.96 0-1.4.74-2.09 1-2.37.26-.28.56-.35.75-.35.19 0 .37 0 .54.01.19.01.44-.07.67.5.24.58.78 1.93.85 2.06.07.14.12.3.02.5-.09.19-.14.3-.28.46-.14.16-.3.35-.42.48-.14.14-.29.29-.12.58.17.29.74 1.22 1.59 1.98.99.88 1.9 1.15 2.19 1.29.28.14.45.12.62-.07.17-.19.74-.85.94-1.15.19-.3.39-.25.65-.15.26.1 1.66.78 1.94.92.28.14.47.21.54.33.07.12.07.72-.21 1.52z" /></svg>
                    <span className="text-[0.65rem] font-bold uppercase tracking-wider">WhatsApp</span>
                </a>
            </nav>

            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Dentist",
                        name: "Kosmix Dental Clinic",
                        telephone: "+919035289171",
                        address: {
                            "@type": "PostalAddress",
                            streetAddress: "1175, 24th Main Rd, near Shri Maramma Devi Devasthana, Garden Layout, Sector 2, HSR Layout",
                            addressLocality: "Bengaluru",
                            addressRegion: "Karnataka",
                            postalCode: "560102",
                            addressCountry: "IN",
                        },
                        geo: {
                            "@type": "GeoCoordinates",
                            latitude: 12.907787,
                            longitude: 77.648582,
                        },
                        openingHours: "Mo-Su 10:00-23:00",
                        aggregateRating: {
                            "@type": "AggregateRating",
                            ratingValue: "4.9",
                            reviewCount: "500",
                        },
                        priceRange: "₹₹",
                    }),
                }}
            />
        </div>
    );
}

